import { CodeField, CodetableMetadata } from '../types-store';
import { CodeFieldWire, CodetableMetadataWire } from '../types';

const mapCodeFieldFromWire = (field: CodeFieldWire): CodeField => ({
  id: field?.id,
  label: field?.label,
  searchRequired: field?.searchRequired ?? false
});

export const mapMetadataFromWire = (metadata: CodetableMetadataWire): CodetableMetadata => ({
  hierarchy: metadata?.hierarchy ?? false,
  category: mapCodeFieldFromWire(metadata?.category),
  type: mapCodeFieldFromWire(metadata?.class)
});
